import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { recognitionSection } from "../../common/constants";
import {
  RECOGNISED_SECTION_MODAL_DETAILS,
  SET_SHOW_RECOGNISED_SECTION,
} from "../../redux/actions/types";
import { useDispatch } from "react-redux";



export const OurLearners = () => {
  const dispatch = useDispatch();
  const [isSliderReady, setIsSliderReady] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const sectionRef = useRef(null);
  const slider1Ref = useRef(null);
  const slider2Ref = useRef(null);
  
  const companiesRow1 = useMemo(() => recognitionSection?.slice(0, recognitionSection?.length / 2), []) || [];
  const companiesRow2 = useMemo(() => recognitionSection?.slice(recognitionSection?.length / 2, recognitionSection?.length), []) || [];

  // Intersection observer to detect when component is in view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Initialize sliders when in view
  useEffect(() => {
    if (isInView) {
      const timer = setTimeout(() => {
        setIsSliderReady(true);
        
        // Fallback: manually start autoplay if needed
        setTimeout(() => {
          if (slider1Ref.current?.innerSlider?.autoPlay) {
            slider1Ref.current.innerSlider.autoPlay();
          }
          if (slider2Ref.current?.innerSlider?.autoPlay) {
            slider2Ref.current.innerSlider.autoPlay();
          }
        }, 100);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [isInView]);

  const handleSlider1Init = useCallback((slider) => {
    slider1Ref.current = slider;
    if (isSliderReady && isInView) {
      setTimeout(() => {
        if (slider?.innerSlider?.autoPlay) {
          slider.innerSlider.autoPlay();
        }
      }, 100);
    }
  }, [isSliderReady, isInView]);

  const handleSlider2Init = useCallback((slider) => {
    slider2Ref.current = slider;
    if (isSliderReady && isInView) {
      setTimeout(() => {
        if (slider?.innerSlider?.autoPlay) {
          slider.innerSlider.autoPlay();
        }
      }, 100);
    }
  }, [isSliderReady, isInView]);
  const handleModal = (item, originalIndex) => {
    // if(swiperInstance){
    //     swiperInstance?.autoplay?.stop()
    // }
    console.log("recognised");
    dispatch({
      type: RECOGNISED_SECTION_MODAL_DETAILS,
      payload: { item, originalIndex },
    });
    dispatch({ type: SET_SHOW_RECOGNISED_SECTION, payload: true });
  };

  useEffect(() => {
    return () => {
      dispatch({ type: SET_SHOW_RECOGNISED_SECTION, payload: false });
    };
  }, [dispatch]);

  return (
    <section 
      ref={sectionRef}
      className="relative mt-11 flex w-full flex-col items-center gap-6 rounded-[24px] bg-[#062E53] p-6 md:mt-[90px] md:gap-10 md:py-6 md:px-10"
    >
      {/* <div className="absolute top-0 left-0 z-[99999] w-[40px] bg-[#062847] h-full "></div> */}
      <header className="flex w-full flex-col  items-center gap-1">
        <p className="whitespace-nowrap text-base font-normal leading-[normal] tracking-[0] text-[#ffffff80] [font-family:'Inter',Helvetica] md:text-[18px]">
          Our Learners Are
        </p>

        <h2
          className="text-center text-2xl font-semibold leading-[normal] tracking-[0] text-white [font-family:'Inter',Helvetica] md:text-[32px] md:font-bold"
          style={{
            background: "linear-gradient(to right, #FFFFFF 0%, #F7E394 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Working At Companies Like
        </h2>
      </header>

      <div className=" relative flex w-full flex-col items-center gap-5 md:gap-5 overflow-hidden">
        <div
          className="absolute top-0 -left-[10px] z-[9999999] h-full w-[80px] md:left-0"
          style={{
            background:
              "linear-gradient(to right, #062E53 0%, rgba(2, 38, 68, 0) 100%)",
          }}
        ></div>
        <div
          className="absolute top-0 -right-4 z-[99999] h-full w-[100px] rotate-180"
          style={{
            background:
              "linear-gradient(to right, #062E53 0%, rgba(2, 38, 68, 0) 100%)",
          }}
        ></div>
         <Slider
           ref={handleSlider1Init}
           dots={false}
           arrows={false}
           infinite={true}
           slidesToShow={6}
           slidesToScroll={1}
           autoplay={isSliderReady && isInView}
           autoplaySpeed={50}
           cssEase="linear"
           speed={2000}
           pauseOnHover={false}
           swipeToSlide={true}
           variableWidth={true}
           className="w-full h-[70px] md:h-auto"
          responsive={[
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
              }
            }
          ]}
        >
          {[...companiesRow1, ...companiesRow1]?.map((company, index) => (
            <div key={`company-row1-${index}`} className="px-2">
              <div
                className="relative inline-flex flex-col items-center justify-center gap-3 rounded border-0 bg-[#0B1D2B]  px-3 py-2 shadow-[0px_4px_10px_0px_rgba(0,0,0,0.25)] before:pointer-events-none before:absolute before:rounded"
                style={{
                  backgroundImage: `radial-gradient(ellipse, #3970B6 0%, #00285B 100%)`,
                }}
                onClick={() => handleModal(company, index)}
              >
                <img
                  className={`w-auto ${
                    window.innerWidth <= 320
                      ? "h-7"
                      : window.innerWidth <= 360
                      ? "h-8"
                      : "h-8"
                  } relative z-10`}
                  alt={""}
                  src={company.companyImage}
                />

                <div className="relative z-10 inline-flex items-center gap-2">
                  <img
                    src={company.profileImage}
                    alt={company.name}
                    className="h-[18px] w-[18px] rounded-full"
                  />

                  <span className="whitespace-nowrap text-xs font-medium leading-3 tracking-[0] text-[#ffffffb2] [font-family:'Inter',Helvetica]">
                    {company.name}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </Slider>

         <Slider
           ref={handleSlider2Init}
           dots={false}
           arrows={false}
           infinite={true}
           slidesToShow={6}
           slidesToScroll={1}
           autoplay={isSliderReady && isInView}
           autoplaySpeed={50}
           cssEase="linear"
           speed={2000}
           pauseOnHover={false}
           swipeToSlide={true}
           variableWidth={true}
           rtl={true}
           className="w-full h-[70px] md:h-auto"
          responsive={[
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
              }
            }
          ]}
        >
          {[...companiesRow2, ...companiesRow2]?.map((company, index) => (
            <div key={`company-row2-${index}`} className="px-2">
              <div
                className="relative inline-flex flex-col items-center justify-center gap-3 rounded border-0 bg-[#0B1D2B] px-3 py-2 shadow-[0px_4px_10px_0px_rgba(0,0,0,0.25)] before:pointer-events-none before:absolute before:inset-0 before:rounded"
                style={{
                  backgroundImage: `radial-gradient(ellipse, #3970B6 0%, #00285B 100%)`,
                }}
                onClick={() =>
                  handleModal(company, index + companiesRow1?.length)
                }
              >
                <img
                  src={company?.companyImage}
                  height={40}
                  width={60}
                  className={`mx-auto ${
                    window.innerWidth <= 320
                      ? "h-7"
                      : window.innerWidth <= 360
                      ? "h-8"
                      : "h-8"
                  } w-auto`}
                  alt=""
                  style={{
                    filter:
                      "drop-shadow(0px 0.5px 0px #424447) drop-shadow(0px 1px 0px #424447) drop-shadow(0px 1.5px 0px #424447) drop-shadow(0px 2px 0px #424447)",
                  }}
                />

                <div className="relative z-10 inline-flex items-center gap-2">
                  <img
                    src={company.profileImage}
                    alt={company.name}
                    className="h-[18px] w-[18px] rounded-full"
                  />

                  <span className="whitespace-nowrap text-xs font-medium leading-3 tracking-[0] text-[#ffffffb2] [font-family:'Inter',Helvetica]">
                    {company.name}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};
